import { DesignData } from 'src/store/design/types';
import getDesignStat from './getDesignStats';

const isDesignHasEmptyContent = (design?: DesignData) => {
  const { totalPagesWithContent, emptyPlaceHolders } = getDesignStat(design);
  return totalPagesWithContent === 0 || emptyPlaceHolders;
};

export default isDesignHasEmptyContent;
